function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// nascondo link serie inglesi in attesa che la redazione popoli la lista
	document
		.querySelector('.filters ul.list-unstyled a[href*="inglesi"]')
		.classList.add("d-none");
});
